import gql from 'graphql-tag'

const updateSpecialPrice = gql`
mutation updateSpecialPrice($id: ID!, $fields: SpecialPriceFields!){
	cashAssist {
		updateSpecialPrice(id: $id, fields: $fields) {
			id
			mod_ver
			type
			typeName
			fromDate
			toDate
			fromTime
			toTime
			weekDays
			dateInterval {
				from
				to
			}
			timeInterval {
				from
				to
			}
			price
			priceInCafe
			tradePrice {
				count
				price
			}
			actionAmount {
				more
				less
			}
			actionDiscount
			actionGroup
			fullDiscount
			codeMWSt
			codeMWSt2
			cashRegisterId
			name
		}
	}
}`

export default updateSpecialPrice
